import { call, put, takeLatest } from 'redux-saga/effects'
import TicketActivitiesAction, { TicketActivitiesTypes } from 'redux/actions/ticketActivitiesAction';
import TicketServices from 'services/ticketServices';
import BaseAction from '../actions/baseAction'
export function* getOpenSupportActivities(action: any): any {
  try {
    const result = yield call(TicketServices.getOpenSupportActivities, action.params);
    if(result.status === 200){
        yield put(TicketActivitiesAction.getOpenSupportActivitiesSuccess(result.data));
    }
  } catch (error) {
    yield put (
      BaseAction.errorHandling({
          message: `GET_OPEN_SUPPORT_ACTIVITIES ${error}`,
      }),
    )
  }
}

export const watchTicketActivities = [
    takeLatest(TicketActivitiesTypes.GET_OPEN_SUPPORT_ACTIVITIES, getOpenSupportActivities),
]